import type { DocumentationV3 } from 'epic/common-form/Documentation';
import type { ISalesCounterpart } from 'models/ISalesCounterpart';
import type { Underlying } from 'models/underlying';
import type { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import type { IHttpClient } from 'utils/http/httpClient.model';

type BaseDocumentationEligibilityRequest = {
  negotiationId: string;
  quoteId?: string;
  wrapper?: string;
  underlyings?: Underlying[];
  selectedOnBehalfClient?: ISalesCounterpart;
  version?: number;
};

export type StatifiedDocumentationEligibilityRequest = BaseDocumentationEligibilityRequest & {
  productSubtype: string;
  productType?: string;
};

export type DynamicDocumentationEligibilityRequest = BaseDocumentationEligibilityRequest & {
  instrumentName: string;
  instrumentContractName: string;
};

export type DocumentationApi = {
  getStatifiedFormDocumentation(request: StatifiedDocumentationEligibilityRequest): Observable<DocumentationV3>;
  getDynamicFormDocumentation(request: DynamicDocumentationEligibilityRequest): Observable<DocumentationV3>;
};

export function documentationApiConnector(httpClient: IHttpClient): DocumentationApi {
  const statifiedFormApi = 'api/v1/statified-form';
  const dynamicFormApi = 'api/v1/dynamic-form';

  function postDocumentation(
    url: string,
    request: StatifiedDocumentationEligibilityRequest | DynamicDocumentationEligibilityRequest,
  ) {
    return httpClient.postJSON<DocumentationV3>({ url, body: request }).pipe(map(({ payload }) => payload));
  }

  return {
    getStatifiedFormDocumentation(request: StatifiedDocumentationEligibilityRequest) {
      return postDocumentation(`${statifiedFormApi}/documentation`, request);
    },
    getDynamicFormDocumentation(request: DynamicDocumentationEligibilityRequest) {
      return postDocumentation(`${dynamicFormApi}/documentation`, request);
    },
  };
}
